module.exports = __webpack_public_path__ + "static/media/Vortex-4WD-RV-5600.20d5f99a.png";